import { Component } from "react";
class NewsList extends Component {
  state = {
    posts: [],
    isLoading: false,
    randomArticle: {
      title: "",
      author: "",
      url: "",
    },
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    const randomId = Math.floor(Math.random() * 20) - 1;
    const responseRand = await fetch(`http://hn.algolia.com/api/v1/items/${randomId}`)
      .then((data) => data.json())
      .then((data) => {
        // console.log(data.title);
        this.setState({ randomArticle: data });
        // console.log(this.state.randomArticle);
      });
    const response = await fetch(`https://hn.algolia.com/api/v1/search?tags=front_page`)
    .then((data) => data.json())
    .then((data) => {
      this.setState({posts: data.hits})
      // console.log(this.state.posts);
    })
  }
  render() {
    const { posts, isLoading, randomArticle } = this.state;
    console.log(posts);
    return (
      <>
        <h2>Random article</h2>
        <div>
            <h3>{randomArticle.title}</h3>
            <p>{randomArticle.author}</p>
            <a href={randomArticle.url}>перейти</a>
        </div>
        <h1>Hacker News</h1>
        <ul>
        {posts.map(({ story_id, author, num_comments, title}) => (
            <li key={story_id}>
              <h3>{title}</h3>
              <p className="contact__name">{author}</p>
              <p className="contact__phone">{num_comments}</p>
            </li>
          ))}
        </ul>
      </>
    );
  }
}

export default NewsList;
